(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tessa-accessories"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__tessaAccLightboxInit) return;
    window.__tessaAccLightboxInit = true;

    function closeLightbox(lb) {
      lb.hidden = true;
      if (lb._returnFocus) {
        try { lb._returnFocus.focus(); } catch (e) {}
        lb._returnFocus = null;
      }
      var imgEl = lb.querySelector('[data-tessa-acc-img]');
      if (imgEl) imgEl.removeAttribute('src');
    }

    function openLightbox(trigger) {
      var section = trigger.closest('[data-tessa-acc]');
      if (!section) return;
      var lb = section.querySelector('[data-tessa-acc-lightbox]');
      if (!lb) return;
      var img = lb.querySelector('[data-tessa-acc-img]');
      var cap = lb.querySelector('[data-tessa-acc-caption]');
      img.src = trigger.dataset.imgSrc;
      img.alt = trigger.dataset.imgAlt || '';
      if (cap) cap.textContent = trigger.dataset.imgAlt || '';
      lb.hidden = false;
      lb._returnFocus = trigger;
      var closeBtn = lb.querySelector('[data-tessa-acc-close]');
      if (closeBtn) closeBtn.focus();
    }

    document.addEventListener('click', function(e) {
      var openEl = e.target.closest('[data-tessa-acc-open]');
      if (openEl) {
        openLightbox(openEl);
        return;
      }

      var closeEl = e.target.closest('[data-tessa-acc-close]');
      if (closeEl) {
        var lbc = closeEl.closest('[data-tessa-acc-lightbox]');
        if (lbc) closeLightbox(lbc);
        return;
      }

      var clickedLb = e.target.closest('[data-tessa-acc-lightbox]');
      if (clickedLb && !e.target.closest('.tessa-acc__lightbox-figure')) {
        closeLightbox(clickedLb);
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var openLb = document.querySelector('[data-tessa-acc-lightbox]:not([hidden])');
        if (openLb) closeLightbox(openLb);
        return;
      }
      if (e.key === 'Enter' || e.key === ' ') {
        var focused = document.activeElement;
        if (focused && focused.matches('[data-tessa-acc-open]')) {
          e.preventDefault();
          openLightbox(focused);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
